import {Component} from '@angular/core'
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog'
import {MatButton} from '@angular/material/button'

@Component({
  selector: 'spb-no-messages',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ],
  templateUrl: './no-messages.component.html',
  styleUrl: './no-messages.component.scss'
})
export class NoMessagesComponent {
}
